export const STATE_NAMES = <const>{
  AK: "Alaska",
  AL: "Alabama",
  AR: "Arkansas",
  AS: "American Samoa",
  AZ: "Arizona",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "District of Columbia",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  IA: "Iowa",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  MA: "Massachusetts",
  MD: "Maryland",
  ME: "Maine",
  MI: "Michigan",
  MN: "Minnesota",
  MO: "Missouri",
  MP: "Northern Mariana Islands",
  MS: "Mississippi",
  MT: "Montana",
  NC: "North Carolina",
  ND: "North Dakota",
  NE: "Nebraska",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NV: "Nevada",
  NY: "New York",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VA: "Virginia",
  VI: "Virgin Islands",
  VT: "Vermont",
  WA: "Washington",
  WI: "Wisconsin",
  WV: "West Virginia",
  WY: "Wyoming",
};

export type StateAbbreviation = keyof typeof STATE_NAMES;

export const stateNamesByAbbreviation = new Map<string, string>(
  Object.entries(STATE_NAMES).map(([abbreviation, name]) => [
    abbreviation,
    name,
  ])
);

// Intentionally manually flipped between reporting years.
export const currentTierIIReportingYear = 2025;

export enum StorageType {
  AboveGroundTank = "Above ground tank",
  Bag = "Bag",
  Battery = "Battery",
  BelowGroundTank = "Below ground tank",
  Box = "Box",
  Can = "Can",
  Carboy = "Carboy",
  Cylinder = "Cylinder",
  Dewar = "Dewar",
  ElectricalEquipment = "Electrical Equipment",
  FiberDrum = "Fiber drum",
  GlassBottlesOrJugs = "Glass bottles or jugs",
  GlassBottlesOrDrums = "Glass bottles or drums",
  HvacEquipment = "HVAC Equipment",
  LeadAcidBattery = "Lead Acid Battery",
  Other = "Other",
  OutdoorStoragePile = "Outdoor storage pile",
  PlasticBottlesOrJugs = "Plastic bottles or jugs",
  PlasticOrNonMetallicDrum = "Plastic or non-metallic drum",
  RailCar = "Rail car",
  Silo = "Silo",
  SteelDrum = "Steel drum",
  SulfuricAcid = "Sulfuric Acid",
  TankCarRailCar = "Tank Car, Rail Car",
  TankInsideBuilding = "Tank inside building",
  TankTruckTankWagon = "Tank Truck, Tank Wagon",
  TankWagon = "Tank wagon",
  ToteBin = "Tote bin",
  UndergroundTank = "Underground Tank",
}

export const STORAGE_TYPE_DESCRIPTIONS = <const>[
  StorageType.AboveGroundTank as string,
  StorageType.Bag as string,
  StorageType.Battery as string,
  StorageType.BelowGroundTank as string,
  StorageType.Box as string,
  StorageType.Can as string,
  StorageType.Carboy as string,
  StorageType.Cylinder as string,
  StorageType.Dewar as string,
  StorageType.ElectricalEquipment as string,
  StorageType.FiberDrum as string,
  StorageType.GlassBottlesOrJugs as string,
  StorageType.HvacEquipment as string,
  StorageType.LeadAcidBattery as string,
  StorageType.Other as string,
  StorageType.OutdoorStoragePile as string,
  StorageType.PlasticBottlesOrJugs as string,
  StorageType.PlasticOrNonMetallicDrum as string,
  StorageType.RailCar as string,
  StorageType.Silo as string,
  StorageType.SteelDrum as string,
  StorageType.SulfuricAcid as string,
  StorageType.TankCarRailCar as string,
  StorageType.TankInsideBuilding as string,
  StorageType.TankTruckTankWagon as string,
  StorageType.TankWagon as string,
  StorageType.ToteBin as string,
  StorageType.UndergroundTank as string,
];
